import ApplicationController from './application_controller'

console.log('Cart summary controller file loaded!')

export default class extends ApplicationController {
  static targets = ['feeCoverageCheckbox', 'details', 'chevron']
  static values = { updateFeeUrl: String }

  connect() {
    super.connect()
    console.log('Cart summary controller connected to element:', this.element)
    console.log('Update fee URL:', this.updateFeeUrlValue)
    this.expanded = false
  }

  // Mobile summary toggle
  toggle(event) {
    if (event) event.preventDefault()
    this.expanded = !this.expanded

    if (this.expanded) {
      this.expand()
    } else {
      this.collapse()
    }
  }

  expand() {
    if (this.hasDetailsTarget) {
      this.detailsTarget.classList.add('expanded')
    }
    if (this.hasChevronTarget) {
      this.chevronTarget.classList.remove('fa-chevron-up')
      this.chevronTarget.classList.add('fa-chevron-down')
    }
  }

  collapse() {
    if (this.hasDetailsTarget) {
      this.detailsTarget.classList.remove('expanded')
    }
    if (this.hasChevronTarget) {
      this.chevronTarget.classList.remove('fa-chevron-down')
      this.chevronTarget.classList.add('fa-chevron-up')
    }
  }

  toggleFeeCoverage(event) {
    const enabled = event.target.checked
    console.log('toggleFeeCoverage called!')
    console.log('Checkbox changed, new value:', enabled)
    
    // Optimistically update the UI immediately
    this.updateFeeCoverageDisplay(enabled)
    
    // Then sync with server
    fetch(this.updateFeeUrlValue, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
      },
      body: JSON.stringify({
        fee_coverage_enabled: enabled
      })
    })
    .then(response => response.json())
    .then(data => {
      if (data.success) {
        console.log('Fee coverage updated, new cart data:', data.cart)
        // Update with actual server values
        this.updateCartDisplay(data.cart)
      } else {
        console.error('Failed to update fee coverage:', data.error)
        // Revert checkbox and UI on error
        event.target.checked = !enabled
        this.updateFeeCoverageDisplay(!enabled)
      }
    })
    .catch(error => {
      console.error('Error updating fee coverage:', error)
      // Revert checkbox and UI on error
      event.target.checked = !enabled
      this.updateFeeCoverageDisplay(!enabled)
    })
  }
  
  updateFeeCoverageDisplay(enabled) {
    try {
      const feeLineElement = document.querySelector('#fee-line')
      const cartTotalElement = document.querySelector('#cart-total')
      const cartSubtotalElement = document.querySelector('#cart-subtotal')
      const cartFeeElement = document.querySelector('#cart-fee')
      
      console.log('updateFeeCoverageDisplay - enabled:', enabled)
      console.log('Elements found:', { feeLineElement, cartTotalElement, cartSubtotalElement, cartFeeElement })
      
      if (feeLineElement) {
        feeLineElement.style.display = enabled ? 'flex' : 'none'
      }
      
      // Calculate fee optimistically
      if (cartSubtotalElement && cartTotalElement) {
        const subtotalText = cartSubtotalElement.textContent.replace(/[^0-9.-]+/g, '')
        const subtotal = parseFloat(subtotalText) || 0
        
        console.log('Subtotal:', subtotal)
        
        let total = subtotal
        let feeAmount = 0
        
        if (enabled) {
          // Givsum fee calculation with gross-up for fee on fee
          const percentage = 0.05 // 2.2% + 2.8% = 5%
          const perChargeFee = 0.30 // Transaction fee
          
          // First calculate base fee
          const baseFee = (subtotal * percentage) + perChargeFee
          // Then gross up to cover the fee on the fee
          feeAmount = baseFee / (1 - percentage)
          feeAmount = Math.round(feeAmount * 100) / 100 // Round to 2 decimals
          
          total = subtotal + feeAmount
        }
        
        console.log('Calculated fee:', feeAmount, 'Total:', total)
        
        const formatter = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD'
        })
        
        if (cartFeeElement) {
          cartFeeElement.textContent = formatter.format(feeAmount)
        }
        
        if (cartTotalElement) {
          cartTotalElement.textContent = formatter.format(total)
        }
      }
    } catch (error) {
      console.error('Error in updateFeeCoverageDisplay:', error)
    }
  }

  updateCartDisplay(cartData) {
    try {
      const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
      })
      
      console.log('updateCartDisplay - cartData:', cartData)
      
      // Update subtotal
      const subtotalElement = document.querySelector('#cart-subtotal')
      if (subtotalElement && cartData.subtotal !== undefined) {
        subtotalElement.textContent = formatter.format(cartData.subtotal)
      }
      
      // Update fee amount and visibility
      const feeElement = document.querySelector('#cart-fee')
      const feeLineElement = document.querySelector('#fee-line')
      
      if (feeElement && cartData.fee_coverage_amount !== undefined) {
        feeElement.textContent = formatter.format(cartData.fee_coverage_amount)
      }
      
      if (feeLineElement) {
        feeLineElement.style.display = (cartData.fee_coverage_amount && cartData.fee_coverage_amount > 0) ? 'flex' : 'none'
      }
      
      // Update total
      const totalElement = document.querySelector('#cart-total')
      if (totalElement && cartData.total !== undefined) {
        totalElement.textContent = formatter.format(cartData.total)
      }
    } catch (error) {
      console.error('Error in updateCartDisplay:', error)
    }
  }
}